import { useEffect, useState } from "react";

import PushNotificationApi from "../../api/pushNotification";
import useCallApi from "../../hooks/useCallApi";
import { useRTL } from "../../hooks/useLanguage/useRTL";

type IPushNotification = {
  id: string;
  message: string;
  dateSent: string;
};

const usePushNotificationsContainer = () => {
  const { callApi, loading } = useCallApi();
  const { isRTL } = useRTL();

  const [pageLoading, setPageLoading] = useState(true);

  const [allPushNotifications, setAllPushNotifications] = useState<
    IPushNotification[]
  >([]);

  const [page, setPage] = useState(1);

  const handleChangePage = (
    pushNotification: React.ChangeEvent<unknown>,
    value: number
  ) => {
    setPage(value);
  };

  useEffect(() => {
    setPageLoading(true);
    callApi(PushNotificationApi.getAll(), (pushNotifications: any) => {
      setAllPushNotifications(pushNotifications);
      setPageLoading(false);
    });
  }, [isRTL]);

  const sortedDescByDateSentPushNotifications = allPushNotifications.sort(
    (a, b) => Date.parse(b.dateSent) - Date.parse(a.dateSent)
  );

  return {
    pushNotifications: sortedDescByDateSentPushNotifications,
    pageLoading,
    page,
    handleChangePage,
    rowsPerPage: 6,
    loading,
  };
};

export default usePushNotificationsContainer;
